import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

import { DropDownMultiCheck } from "../DropDownMultiCheck";

export default function JobRole() {
  const { searchObject, setSearchObject, t } = useAdvanceSearchContext();
  const [jobRolesList, setJobRolesList] = useState([]);

  useEffect(() => {
    CommonService.getAllJobRoles().then((data) => setJobRolesList(data));
  }, []);

  function setJobRoles(list) {
    setSearchObject({ ...searchObject, jobRoles: list });
  }
  return (
    <fieldset>
      {" "}
      <legend>{t("Job Role")}</legend>
      <DropDownMultiCheck
        dataList={jobRolesList}
        selecteds={searchObject.jobRoles}
        setSelecteds={setJobRoles}
      />
    </fieldset>
  );
}
